import * as Yup from "yup";

export const notableAlumnusSchema = Yup.object().shape({
  first_name: Yup.string()
    .required("Name field cannot be empty")
    .max(255, "Name cannot exceed 255 characters"),
  last_name: Yup.string()
    .required("Name field cannot be empty")
    .max(255, "Name cannot exceed 255 characters"),
  description: Yup.string().nullable(),
  achievements: Yup.string().nullable(),
  photo: Yup.string().nullable(),
  institution_id: Yup.string().required(
    "Institution is required"
  ),
});
